import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-forgot-password-redirect',
  standalone: true,
  template: "",
})
export class ForgotPasswordRedirectComponent implements OnInit{
  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    // Extract the token from query parameters
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      if (token) {
        this.router.navigate(['/forgot-password-confirm'], { queryParams: { token } });
      }
    });
  }
}
